/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Teasers {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section, CmsImage } from "@bw/bits"
import { Teasers as TeasersModule } from "@bw/modules"
import { Teaser } from "@bw/partials"
import { graphql } from "gatsby"

const TeasersCustom = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  items,
  numberOfColumns,
}) => {
  return (
    <Section {...{ suptitle, title, subtitle, button, buttonPosition }}>
      <TeasersModule numberOfColumns={parseInt(numberOfColumns.value)}>
        {items.map((item, i) => {
          return (
            <Teaser
              key={i}
              suptitle={item.custom_suptitle}
              title={item.custom_title}
              image={
                <CmsImage src={item.customImage} alt={item.custom_title} />
              }
              subtitle={item.custom_linkType.value}
              href={
                item.custom_linkType.value === "url" ? item.custom_url : null
              }
              to={
                item.custom_linkType.value === "entry" && item.custom_entry
                  ? item.custom_entry.url
                  : null
              }
            />
          )
        })}
      </TeasersModule>
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on TeasersCustomModule {
 *   ...TeasersCustomModuleFragment
 * }
 *
 * This is also what you will get in the props of your {{pascalCase name}}
 * resolver component.
 */
export const query = graphql`
  fragment TeasersCustomModuleFragment on TeasersCustomModule {
    numberOfColumns {
      value
    }

    items {
      custom_isExternal
      custom_linkText
      custom_linkType {
        value
      }
      custom_entry {
        url
      }
      custom_url
      customImage {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 800, height: 450)
          }
        }
      }
      customTag
      custom_suptitle
      custom_title
      custom_subtitle
      customContent
    }
  }
`

export { TeasersCustom }
